// Mock data for FoodQuest

export const cuisineTypes = [
  'Italian', 'Chinese', 'Japanese', 'Indian', 'Mexican', 
  'Thai', 'American', 'French', 'Mediterranean', 'Korean'
];

export const priceRanges = ['$', '$$', '$$$', '$$$$'];

export const restaurants = [
  {
    id: 1,
    name: 'Bella Italia Trattoria',
    cuisine: 'Italian',
    rating: 4.8,
    reviews: 342,
    priceRange: '$$$',
    location: 'Sydney CBD',
    address: '123 George St, Sydney NSW 2000',
    image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=600&q=75',
    description: 'Authentic Italian cuisine with a modern twist. Family recipes passed down through generations.',
    openNow: true,
    featured: true,
    latitude: -33.8688,
    longitude: 151.2093,
    phone: '(02) 9876 5432',
    hours: 'Mon-Sun: 11:00 AM - 10:00 PM',
    tags: ['Pasta', 'Pizza', 'Wine Bar']
  },
  {
    id: 2,
    name: 'Golden Dragon Palace',
    cuisine: 'Chinese',
    rating: 4.6,
    reviews: 456,
    priceRange: '$$',
    location: 'Chinatown',
    address: '45 Dixon St, Haymarket NSW 2000',
    image: 'https://images.unsplash.com/photo-1525755662778-989d0524087e?w=600&q=75',
    description: 'Traditional Cantonese dim sum and authentic Chinese dishes in a vibrant atmosphere.',
    openNow: true,
    featured: true,
    latitude: -33.8790,
    longitude: 151.2041,
    phone: '(02) 9123 4567',
    hours: 'Mon-Sun: 10:00 AM - 11:00 PM',
    tags: ['Dim Sum', 'Noodles', 'Seafood']
  },
  {
    id: 3,
    name: 'Sakura Sushi Bar',
    cuisine: 'Japanese',
    rating: 4.9,
    reviews: 289,
    priceRange: '$$$$',
    location: 'Darling Harbour',
    address: '78 Harbour St, Sydney NSW 2000',
    image: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=600&q=75',
    description: 'Premium sushi and sashimi crafted by award-winning chefs using the freshest ingredients.',
    openNow: false,
    featured: true,
    latitude: -33.8737,
    longitude: 151.2006,
    phone: '(02) 9234 5678',
    hours: 'Tue-Sun: 5:00 PM - 11:00 PM',
    tags: ['Sushi', 'Sashimi', 'Omakase']
  },
  {
    id: 4,
    name: 'Spice Route',
    cuisine: 'Indian',
    rating: 4.7,
    reviews: 523,
    priceRange: '$$',
    location: 'Surry Hills',
    address: '92 Crown St, Surry Hills NSW 2010',
    image: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=600&q=75',
    description: 'North and South Indian specialties with bold flavors and aromatic spices.',
    openNow: true,
    featured: false,
    latitude: -33.8860,
    longitude: 151.2142,
    phone: '(02) 9345 6789',
    hours: 'Mon-Sun: 11:30 AM - 10:30 PM',
    tags: ['Curry', 'Tandoori', 'Biryani']
  },
  {
    id: 5,
    name: 'La Cantina',
    cuisine: 'Mexican',
    rating: 4.5,
    reviews: 412,
    priceRange: '$$',
    location: 'Newtown',
    address: '156 King St, Newtown NSW 2042',
    image: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=600&q=75',
    description: 'Vibrant Mexican eatery serving tacos, burritos, and margaritas in a lively setting.',
    openNow: true,
    featured: false,
    latitude: -33.8969,
    longitude: 151.1804,
    phone: '(02) 9456 7890',
    hours: 'Mon-Sun: 12:00 PM - 11:00 PM',
    tags: ['Tacos', 'Burritos', 'Cocktails']
  },
  {
    id: 6,
    name: 'Bangkok Bites',
    cuisine: 'Thai',
    rating: 4.6,
    reviews: 367,
    priceRange: '$',
    location: 'Bondi Beach',
    address: '23 Campbell Pde, Bondi Beach NSW 2026',
    image: 'https://images.unsplash.com/photo-1559314809-0d155014e29e?w=600&q=75',
    description: 'Casual Thai restaurant with beachside views and authentic street food favorites.',
    openNow: true,
    featured: false,
    latitude: -33.8915,
    longitude: 151.2767,
    phone: '(02) 9567 8901',
    hours: 'Mon-Sun: 11:00 AM - 9:00 PM',
    tags: ['Pad Thai', 'Curry', 'Street Food']
  }
];

export const deals = [
  {
    id: 1,
    restaurantId: 1,
    restaurantName: 'Bella Italia Trattoria',
    title: '50% Off All Pasta Dishes',
    description: 'Enjoy half price on our entire pasta menu. Available Monday to Thursday.',
    originalPrice: 45,
    discountPrice: 22.50,
    discount: 50,
    image: 'https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=600&q=75',
    validUntil: '2025-08-31',
    purchased: 234,
    terms: 'Valid Mon-Thu only. Not valid with other offers.',
    category: 'Food & Dining'
  },
  {
    id: 2,
    restaurantId: 2,
    restaurantName: 'Golden Dragon Palace',
    title: 'Dim Sum Lunch Special',
    description: 'Unlimited dim sum with tea for 90 minutes. Perfect for groups!',
    originalPrice: 38,
    discountPrice: 25,
    discount: 34,
    image: 'https://images.unsplash.com/photo-1563245372-f21724e3856d?w=600&q=75',
    validUntil: '2025-09-15',
    purchased: 567,
    terms: 'Available 11 AM - 3 PM daily. Minimum 2 people.',
    category: 'Food & Dining'
  },
  {
    id: 3,
    restaurantId: 3,
    restaurantName: 'Sakura Sushi Bar',
    title: 'Omakase Experience for Two',
    description: 'Premium 12-course tasting menu with sake pairing.',
    originalPrice: 280,
    discountPrice: 199,
    discount: 29,
    image: 'https://images.unsplash.com/photo-1583623025817-d180a2221d0a?w=600&q=75',
    validUntil: '2025-08-20',
    purchased: 89,
    terms: 'Advance booking required. Available Tue-Thu only.',
    category: 'Fine Dining'
  },
  {
    id: 4,
    restaurantId: 5,
    restaurantName: 'La Cantina',
    title: 'Taco Tuesday - Buy 3 Get 3 Free',
    description: 'Every Tuesday, get double the tacos! Mix and match any flavors.',
    originalPrice: 24,
    discountPrice: 12,
    discount: 50,
    image: 'https://images.unsplash.com/photo-1551504734-5ee1c4a1479b?w=600&q=75',
    validUntil: '2025-12-31',
    purchased: 891,
    terms: 'Valid Tuesdays only. Dine-in only.',
    category: 'Food & Dining'
  }
];

export const events = [
  {
    id: 1,
    title: 'Sydney Food & Wine Festival',
    description: 'Celebrate the best of Sydney\'s culinary scene with tastings from over 50 restaurants, wineries, and food trucks.',
    image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=600&q=75',
    date: '2025-08-15',
    endDate: '2025-08-18',
    time: '10:00 AM - 10:00 PM',
    location: 'The Domain, Sydney',
    price: 45,
    category: 'Festival',
    attendees: 2340,
    organizer: 'Sydney Food Events',
    featured: true
  },
  {
    id: 2,
    title: 'Italian Cooking Masterclass',
    description: 'Learn to make authentic pasta and tiramisu from Chef Marco. All ingredients and wine included.',
    image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=600&q=75',
    date: '2025-07-22',
    time: '6:00 PM - 9:00 PM',
    location: 'Bella Italia Trattoria',
    price: 95,
    category: 'Workshop',
    attendees: 45,
    organizer: 'Bella Italia Trattoria',
    featured: true
  },
  {
    id: 3,
    title: 'Street Food Market Night',
    description: 'Experience flavors from around the world at Sydney\'s biggest street food gathering.',
    image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=600&q=75',
    date: '2025-07-25',
    time: '5:00 PM - 11:00 PM',
    location: 'Darling Harbour',
    price: 0,
    category: 'Market',
    attendees: 5600,
    organizer: 'Sydney Night Markets',
    featured: false
  },
  {
    id: 4,
    title: 'Wine Tasting Evening',
    description: 'Sample 12 premium wines paired with artisan cheeses and charcuterie.',
    image: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=600&q=75',
    date: '2025-07-28',
    time: '7:00 PM - 10:00 PM',
    location: 'The Wine Cellar, Circular Quay',
    price: 75,
    category: 'Tasting',
    attendees: 120,
    organizer: 'Sydney Wine Society',
    featured: false
  }
];

export const userProfile = {
  id: 1,
  name: 'Sarah Johnson',
  username: '@saraheats',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
  bio: 'Food enthusiast | Sydney foodie | Always hunting for the best brunch spots',
  followers: 1234,
  following: 567,
  posts: 89,
  verified: true,
  joinedDate: '2024-01-15'
};

export const userPosts = [
  {
    id: 1,
    userId: 1,
    userName: 'Sarah Johnson',
    userAvatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
    restaurantId: 1,
    image: 'https://images.unsplash.com/photo-1563379926898-05f4575a45d8?w=600&q=75',
    caption: 'Best carbonara in town! 🍝 The pasta was perfectly al dente.',
    likes: 234,
    comments: 23,
    timestamp: '2025-07-10T14:30:00',
    location: 'Bella Italia Trattoria'
  },
  {
    id: 2,
    userId: 1,
    userName: 'Sarah Johnson',
    userAvatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
    restaurantId: 3,
    image: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=600&q=75',
    caption: 'Omakase experience was absolutely incredible! Worth every penny 🍣',
    likes: 456,
    comments: 45,
    timestamp: '2025-07-08T19:00:00',
    location: 'Sakura Sushi Bar'
  },
  {
    id: 3,
    userId: 1,
    userName: 'Sarah Johnson',
    userAvatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
    restaurantId: 5,
    image: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=600&q=75',
    caption: 'Taco Tuesday done right! 🌮 The margaritas were amazing too',
    likes: 189,
    comments: 12,
    timestamp: '2025-07-05T20:15:00',
    location: 'La Cantina'
  }
];

export const savedRestaurants = [1, 3, 4];

export const reviews = [
  {
    id: 1,
    restaurantId: 1,
    userId: 1,
    userName: 'Sarah Johnson',
    userAvatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200',
    rating: 5,
    comment: 'Absolutely phenomenal! The pasta was cooked to perfection and the service was outstanding.',
    timestamp: '2025-07-10T15:00:00',
    helpful: 23,
    images: ['https://images.unsplash.com/photo-1563379926898-05f4575a45d8?w=400']
  },
  {
    id: 2,
    restaurantId: 1,
    userId: 2,
    userName: 'Mike Chen',
    userAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200',
    rating: 4,
    comment: 'Great Italian food, though a bit pricey. The ambiance was lovely.',
    timestamp: '2025-07-05T19:30:00',
    helpful: 12
  }
];
